// eslint-disable-next-line import/prefer-default-export
export const GET_OVERTIME_MY_REQUESTS_SUCCESS =
  'GET_OVERTIME_MY_REQUESTS_SUCCESS';
export const GET_OVERTIME_MY_REQUESTS_ERROR = 'GET_OVERTIME_MY_REQUESTS_ERROR';
export const GET_OVERTIME_MY_REQUESTS_PENDING =
  'GET_OVERTIME_MY_REQUESTS_PENDING';
export const SET_OVERTIME_MY_REQUESTS = 'SET_OVERTIME_MY_REQUESTS';

export const GET_TIME_ADJUSTMENT_MY_REQUESTS_SUCCESS =
  'GET_TIME_ADJUSTMENT_MY_REQUESTS_SUCCESS';
export const GET_TIME_ADJUSTMENT_MY_REQUESTS_ERROR =
  'GET_TIME_ADJUSTMENT_MY_REQUESTS_ERROR';
export const GET_TIME_ADJUSTMENT_MY_REQUESTS_PENDING =
  'GET_TIME_ADJUSTMENT_MY_REQUESTS_PENDING';
export const SET_TIME_ADJUSTMENT_MY_REQUESTS =
  'SET_TIME_ADJUSTMENT_MY_REQUESTS';
